import Image from 'next/image';
import Link from 'next/link';

import { DEFAULT_GRAYSCALE_IMAGE } from '@components/controls/future/Picture';

import { colors, scale, typography } from '@scripts/gds';
import { useMedia } from '@scripts/hooks';

const CategoryPanel = ({
    link,
    image,
    name,
    isBig,
}: {
    link: string;
    image: string | null;
    name: string;
    isBig?: boolean;
}) => {
    const { sm } = useMedia();

    // todo prefFalse
    return (
        <div
            css={{
                padding: isBig ? scale(3) : scale(2),
                backgroundColor: colors.backgroundMain,
                height: '100%',
                textAlign: 'center',
                minWidth: 'fit-content',
                [sm]: { backgroundColor: 'transparent', padding: 0 },
            }}
        >
            <Link legacyBehavior href={link} prefetch={false} passHref>
                <a
                    aria-label={link}
                    css={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: scale(3, true),
                        height: '100%',
                        ...typography('link'),
                    }}
                >
                    <div
                        css={{
                            position: 'relative',
                            width: '100%',
                            height: '100%',
                            [sm]: {
                                backgroundColor: colors.backgroundMain,
                                padding: scale(2),
                            },
                        }}
                    >
                        {image && (
                            <Image
                                src={image}
                                blurDataURL={DEFAULT_GRAYSCALE_IMAGE}
                                placeholder="blur"
                                alt={name}
                                fill
                                css={{ objectFit: 'contain', objectPosition: 'center center' }}
                            />
                        )}
                    </div>
                    {name}
                </a>
            </Link>
        </div>
    );
};

export default CategoryPanel;
